import React, { ChangeEvent, useState } from 'react';
import { Box, Flex, TextField } from '@radix-ui/themes';
import * as Label from '@radix-ui/react-label';
import { useDispatch, useSelector } from 'react-redux';

import { Footer } from '../../../layout/footer/Footer';
import useLanguage from '../../../contexts/language/LanguageContext';
import { Page, TransitionUrl, TranslationPath } from '../../../contexts/kioskConfiguration/type';
import {
  setFetchedTransportation,
  setTransportationForm
} from '../../../store/slices/transportation/transportationSlice';
import { findTransportation } from '../../../apollo/queries/findTransportation';
import { RootState } from '../../../store/store';
import { getTranslationByPath } from '../../../utils/translations';
import { addNotification } from '../../../store/slices/notification/notificationSlice';
import { MainContent } from '../../../layout/content/MainContent';
import { KeyboardWrapper } from '../../../components/keyboard/KeyboardWrapper';
import { setSelectedPage } from '../../../store/slices/app/appSlice';


export type RsPinTemplateType = {
  transitionUrl: TransitionUrl
  rsPinInputLabel: TranslationPath
  rsPinInputPlaceholder: TranslationPath
  notFoundText: TranslationPath
}

type Props = {
  page: Page<RsPinTemplateType>
}


export const RsPinTemplate = (props: Props): React.ReactElement => {
  const [isProcessing, setIsProcessing] = React.useState(false);

  const language = useLanguage();
  const dispatch = useDispatch()

  const transportationForm = useSelector((state: RootState) => state.transportation.transportationForm)
  const [value, setValue] = useState<string>('');

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value)
  }

  const onContinue = async () => {
    if (value.length === 0) {
      dispatch(addNotification(
        { type: 'error', title: getTranslationByPath(language.translations, props.page.data.notFoundText) },
      ))
      return
    }

    setIsProcessing(true);

    const findTransportationResult = await findTransportation({
      value,
      findBy: 'rsPin',
      qtirLanguageId: language.qtirLanguageId,
    })

    const foundTransportation = findTransportationResult.data.findTransportation.transportation
    if (!foundTransportation) {
      dispatch(addNotification(
        { type: 'error', title: getTranslationByPath(language.translations, props.page.data.notFoundText) },
      ))
      setIsProcessing(false);
      return
    }

    dispatch(setFetchedTransportation(foundTransportation))
    dispatch(setTransportationForm({
      ...transportationForm,
      registrationNumber: foundTransportation.registrationNumber,
      driverName: foundTransportation.driverName,
      phoneNumber: foundTransportation.driverPhoneNumber,
      carQuantity: foundTransportation.carQuantity,
      carCompanyId: foundTransportation.carCompanyId,
      destinationId: foundTransportation.destinationId,
    }))

    setIsProcessing(false);
    dispatch(setSelectedPage(props.page.data.transitionUrl))
  }

  return (
    <>
      <MainContent>
        <Flex className="flex-col justify-center items-center w-full mt-10">
          <Flex direction="column" gap="1" width="100%" className="items-center">
            <Box maxWidth="500px" className="w-full">
              <Label.Root className="LabelRoot text-2xl mb-10" htmlFor="identification">
                {getTranslationByPath(language.translations, props.page.data.rsPinInputLabel)}
              </Label.Root>
              <KeyboardWrapper layout="numeric" title={getTranslationByPath(language.translations, props.page.data.rsPinInputLabel)}>
                <TextField.Root
                  style={{ height: '50px' }}
                  className="mt-3"
                  placeholder={getTranslationByPath(language.translations, props.page.data.rsPinInputPlaceholder)}
                  onChange={onChange}
                />
              </KeyboardWrapper>
            </Box>
          </Flex>
        </Flex>
      </MainContent>

      <Footer backUrl={props.page.footer?.back} onContinue={onContinue} disabledBackBtn={isProcessing} disabledContinueBtn={isProcessing} />
    </>
  )
}
